var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-button-upload-content"},[_c('v-file-input',{attrs:{"label":"Upload Data File","accept":"application/json","prepend-icon":"mdi-paperclip","outlined":""},model:{value:(_vm.attachment),callback:function ($$v) {_vm.attachment=$$v},expression:"attachment"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }